var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9496 26.364C25.1372 26.5515 25.3915 26.6569 25.6567 26.6569C25.922 26.6569 26.1763 26.5515 26.3639 26.364C26.5514 26.1764 26.6567 25.9221 26.6567 25.6569C26.6567 25.3916 26.5514 25.1373 26.3639 24.9497L21.4141 20L26.3639 15.0503C26.5514 14.8627 26.6567 14.6084 26.6567 14.3431C26.6567 14.0779 26.5514 13.8236 26.3639 13.636C26.1763 13.4485 25.922 13.3431 25.6567 13.3431C25.3915 13.3431 25.1372 13.4485 24.9496 13.636L19.9999 18.5858L15.0501 13.636C14.8626 13.4485 14.6083 13.3431 14.343 13.3431C14.0778 13.3431 13.8235 13.4485 13.6359 13.636C13.4484 13.8236 13.343 14.0779 13.343 14.3431C13.343 14.6084 13.4484 14.8627 13.6359 15.0503L18.5857 20L13.6359 24.9497C13.4484 25.1373 13.343 25.3916 13.343 25.6569C13.343 25.9221 13.4484 26.1764 13.6359 26.364C13.8235 26.5515 14.0778 26.6569 14.343 26.6569C14.6083 26.6569 14.8626 26.5515 15.0501 26.364L19.9999 21.4142L24.9496 26.364Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.7dd92e50535fd8e9e01fded4dfbf4ab1.svg";
export { ForwardRef as ReactComponent };